import { render, staticRenderFns } from "./PendingParticipants.vue?vue&type=template&id=70b2f953&"
import script from "./PendingParticipants.vue?vue&type=script&lang=js&"
export * from "./PendingParticipants.vue?vue&type=script&lang=js&"
import style0 from "./PendingParticipants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports